import React, { useState } from 'react';
import { Select, MenuItem } from '@material-ui/core';
import { borderColor } from './common';

const EAA_Select = ({
  list = [],
  onChange = () => {},
  value = '',
  disabled = false,
  displayBorder = false,
  displayEmpty = true,
  hint = '請選擇',
  marginRight = 50,
  multiple = false,
  autoWidth = false,
  unit = null,
  label = null,
}) => {
  const [over, setOver] = useState(false);
  const [focus, setFocus] = useState(false);
  const EndAdornment = () => unit ? <div style={{ color: 'gray', marginLeft: 8, whiteSpace: 'nowrap', marginRight: 20 }}>{unit}</div> : null;
  const StartAdornment = () => label ? <div style={{ color: 'color', marginLeft: 8, marginRight: 8, whiteSpace: 'nowrap' }}>{label}</div> : null;
  const pair = () => {
    for (const o of list) {
      if (multiple && (typeof (value) === 'object') && value.length && (value.indexOf(o.value) > -1)) return true;
      if (!multiple && (value === o.value)) return true;
    }
    return false;
  };
  const NPair = value && value.length > 0 && !pair();
  return (
    <div style={{ flex: 1, width: 0, height: 46, marginRight }}>
      <Select
        readOnly={disabled}
        // MenuProps={{ style: { top: 48 } }}
        style={{
          borderRadius: 14,
          width: '100%',
          height: 46,
          backgroundColor: disabled ? '#ededed' : 'white',
          textAlign: 'start',
          paddingLeft: 12,
          border: ((displayBorder || over || focus) && !disabled) ? `1px solid ${(over || focus) ? 'black' : borderColor}` : '',
          color: NPair ? 'red' : (pair() ? 'black' : '#B8B8B8'),
          cursor: 'pointer',
        }}
        disableUnderline
        displayEmpty={displayEmpty}
        value={pair() ? value : (multiple ? [''] : '')}
        onChange={e => {
          if (multiple) {
            const data = e.target.value;
            if (data.indexOf('') > -1)data.splice(data.indexOf(''), 1);
            onChange(data);
          } else {
            onChange(e.target.value);
          }
        }}
        onMouseOver={() => setOver(true)}
        onMouseOut={() => setOver(false)}
        onBlur={() => { setFocus(false); setOver(false); } }
        onFocus={() => setFocus(true)}
        multiple={multiple}
        autoWidth={autoWidth}
        endAdornment={<EndAdornment />}
        startAdornment={<StartAdornment />}
      >
        {hint && hint.length > 0 && <MenuItem disabled={!!NPair} style={{ color: NPair ? 'red' : '#b8b8b8' }} value="">{NPair ? '匹配錯誤' : hint}</MenuItem>}
        {list.map((o, i) => <MenuItem key={i} value={o.value}>{o.name}</MenuItem>)}
      </Select>
    </div>
  );
};

export default EAA_Select;
